const ACTION_ECONOMY_FLAGS = Object.freeze([
  { flag: 'actionUsed', slot: 'action', fallbackName: 'Action' },
  { flag: 'bonusActionUsed', slot: 'bonus_action', fallbackName: 'Bonus Action' },
  { flag: 'reactionUsed', slot: 'reaction', fallbackName: 'Reaction' },
  { flag: 'freeObjectUsed', slot: 'free_object', fallbackName: 'Free/Object Interaction' },
]);

const latestActionName = (actionsThisTurn, slot, fallbackName) => {
  const matching = (Array.isArray(actionsThisTurn) ? actionsThisTurn : [])
    .filter((entry) => String(entry?.type || '') === slot && String(entry?.name || '').trim());
  return matching.length > 0 ? String(matching[matching.length - 1].name).trim() : fallbackName;
};

/**
 * Translate false-to-true token combat-flag transitions into the dedicated
 * authoritative action-economy commands. Generic token/map patches are not
 * permitted to spend mechanical resources, so reconnect-safe combat must
 * commit these slots explicitly before advancing local state.
 * date_of_change: 2026-08-26
 */
export const buildActionEconomySpendRequests = ({
  tokenId,
  currentCombatFlags = {},
  nextCombatFlags = {},
  actionsThisTurn = [],
} = {}) => {
  if (!tokenId || !nextCombatFlags || typeof nextCombatFlags !== 'object') return [];

  return ACTION_ECONOMY_FLAGS.flatMap(({ flag, slot, fallbackName }) => {
    if (nextCombatFlags[flag] !== true || currentCombatFlags?.[flag] === true) return [];
    return [{
      tokenId: String(tokenId),
      economySlot: slot,
      actionName: latestActionName(actionsThisTurn, slot, fallbackName),
    }];
  });
};

export default buildActionEconomySpendRequests;
